// WHERE A PAGE LIVES ON THE PUBLIC INTERNET, and the one place that shape is
// declared.
//
// Two readers, and they must not be allowed to drift. The renderer builds the
// canonical URL and the hreflang set out of it (common/render/page), and the
// app links an author to their own published page out of it (the pages
// listing, the page screen and the editor). A URL written out twice is a URL
// that diverges the first time anybody touches the trailing slash, and the
// failure there is silent on both sides: a canonical that 301s, and an "open
// the live page" link that takes an author to the redirect rather than to the
// page.
//
// The hostname comes from a `SiteDomain` row and is normalized by the module
// that owns that table's key, not here — see @common/schema/site-domain/host.
import { normalizeHost } from "@common/schema/site-domain/host";

// A route as it appears in a URL a crawler is given: canonical form, plus the
// trailing slash the viewer-request function 301s to. Canonicalising to a URL
// that immediately redirects is a self-inflicted crawl budget problem, and it
// is the sort of thing nobody notices for a year.
export const routeUrl = (base, route) => {
  const trimmed = String(route || "").replace(/\/+$/, "");
  return `${base}${trimmed === "" ? "/" : `${trimmed}/`}`;
};

// The address a visitor types, for a page served on one of its site's attached
// hostnames.
//
// Empty string when there is no host, which is the state of every site nobody
// has attached a domain to yet — the caller draws nothing rather than a link to
// `https:///pricing/`. That is a real state and not an error: a site is
// editable and previewable from the day it is created, and it becomes
// reachable when a domain is attached AND verified (see
// @common/schema/site-domain/status).
//
// Always https. The renderer is only ever reached through the distribution and
// the viewer-request function redirects http, so a link to the http form is a
// link to a redirect.
export const pageUrl = (host, route) => {
  const normalized = normalizeHost(host);

  return normalized ? routeUrl(`https://${normalized}`, route) : "";
};
